export default __webpack_public_path__ + "static/media/logo.2f63f76a.svg";